import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../auth/authSlice";

// import { AcceptAgencyInviteCall, FilterCreatorsCatalogue, GetFavouriteCreatorsApi, RejectAgencyInviteCall, getCreators } from "Common/Repository";
import { AcceptAgencyInviteCall, FilterCreatorsCatalogue, getCreators, GetFavouriteCreatorsApi, RejectAgencyInviteCall } from "actions/creatorAction";

const initialState = {
    acceptAgencyLoading: false,
    rejectAgencyLoading: false,
    loading: false,
    creatorsData: [],
    error: null,
    success: false,
    // Filters States
    filterLoading: false,
    favLoading: false,
    filterSuccess: false,
    filterError: null,
    creatorsCurrentPage: 1,
    creatorsTotalPages: 0,
    creatorsLastfetched: null,
};

const creatorSlice = createSlice({
    name: 'creators',
    initialState,
    reducers: {
        setCreators: (state, action) => {
            const data = Array.isArray(action?.payload?.data)
                ? action.payload.data
                : Array.isArray(action?.payload?.data?.data)
                    ? action.payload.data.data
                    : Array.isArray(action?.payload)
                        ? action?.payload : [];

            state.creatorsData = data;
            state.creatorsCurrentPage = action?.payload?.current_page;
            state.creatorsTotalPages = action?.payload?.last_page;
        },
        setCreatorsCurrentPage: (state, action) => {
            state.creatorsCurrentPage = action?.payload;
        },
        setCreatorsLastPage: (state, action) => {
            state.creatorsTotalPages = action?.payload;
        },
        resetCreatorsCurrentPage: (state, action) => {
            state.creatorsCurrentPage = 1;
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(logout, (state) => {
                state.creatorsData = [];
                state.loading = false;
                state.success = false;
            })
            .addCase(getCreators.pending, (state) => {
                if (!state.creatorsData?.length) {
                    state.loading = true;
                }
                state.error = null;
            })
            .addCase(getCreators.fulfilled, (state, action) => {
                const data = Array.isArray(action.payload?.data)
                    ? action.payload.data
                    : Array.isArray(action.payload?.data?.data?.data)
                        ? action.payload.data.data.data
                        : [];
                state.creatorsData = data;
                state.loading = false;
                state.error = null;
                state.creatorsCurrentPage = action?.payload?.data?.data?.current_page;
                state.creatorsTotalPages = action?.payload?.data?.data?.last_page;
            })

            .addCase(getCreators.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(FilterCreatorsCatalogue.pending, (state) => {
                state.filterSuccess = false;
                state.filterLoading = true;
                state.error = null;

            })
            .addCase(FilterCreatorsCatalogue.fulfilled, (state, action) => {
                const data = Array.isArray(action.payload?.data)
                    ? action.payload.data
                    : Array.isArray(action.payload?.data?.data?.data)
                        ? action.payload.data.data.data
                        : [];

                // check late : many record => bad ux
                // console.log(data.length);

                // state.creatorsData = data;
                state.creatorsData = data.slice(0,100);
                state.filterLoading = false;
                state.filterSuccess = true;
                state.error = null;
                state.creatorsCurrentPage = action?.payload?.data?.data?.current_page;
                state.creatorsTotalPages = action?.payload?.data?.data?.last_page;
                let newdate = new Date().getTime();
                state.lastFetched = newdate ?? newdate // Update the last fetched timestamp
            })
            .addCase(FilterCreatorsCatalogue.rejected, (state, action) => {
                state.filterLoading = false;
                state.error = action.payload;
                // FAVOURITE CREATORS
            })
            .addCase(GetFavouriteCreatorsApi.pending, (state) => {
                state.favLoading = true;
            })
            .addCase(GetFavouriteCreatorsApi.fulfilled, (state, action) => {
                const data = Array.isArray(action.payload?.data)
                    ? action.payload.data
                    : Array.isArray(action.payload?.data?.data?.data)
                        ? action.payload.data.data.data
                        : [];

                state.creatorsData = data.map((d) => d.creator);
                state.creatorsCurrentPage = action?.payload?.data?.current_page;
                state.creatorsTotalPages = action?.payload?.data?.last_page;
                state.favLoading = false;
            })
            .addCase(GetFavouriteCreatorsApi.rejected, (state, action) => {
                state.favLoading = false;
            })


            .addCase(AcceptAgencyInviteCall.pending, (state) => {
                state.acceptAgencyLoading = true;
            })
            .addCase(AcceptAgencyInviteCall.fulfilled, (state, action) => {
                state.acceptAgencyLoading = false;
            })
            .addCase(AcceptAgencyInviteCall.rejected, (state, action) => {
                state.acceptAgencyLoading = false;
            })




            .addCase(RejectAgencyInviteCall.pending, (state) => {
                state.rejectAgencyLoading = true;
            })
            .addCase(RejectAgencyInviteCall.fulfilled, (state, action) => {
                state.rejectAgencyLoading = false;
            })
            .addCase(RejectAgencyInviteCall.rejected, (state, action) => {
                state.rejectAgencyLoading = false;
            })



    },
});

export const { setCreators, setCreatorsCurrentPage, resetCreatorsCurrentPage, setCreatorsLastPage } = creatorSlice.actions;
export default creatorSlice.reducer;
